import { render } from "./Nieuws.vue?vue&type=template&id=1c0b9361"
import script from "./Nieuws.vue?vue&type=script&lang=js"
export * from "./Nieuws.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__